import React from 'preact/compat'

import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Label from './Label';
import colors from '../colors';

import { toggleValue } from '../../state/utils';
import { useAdvancedMode } from '../../state/advancedModeStore';

import CheckboxCheckedIcon from '../icons/CheckboxCheckedIcon';
import CheckboxUncheckedIcon from '../icons/CheckboxUncheckedIcon';

export const CheckboxSelector = ({id, label, options, value, setValue, description, row}) => {
    const handleChange = (e) => {
        const checkBoxValue = e.target.value;
        setValue(toggleValue(value, checkBoxValue));
    }
    const [advancedMode, ] = useAdvancedMode();

    return (
    <FormControl>
        <Label id={id} label={label} description={description} />
        <FormGroup
            aria-labelledby={id + "-label"}
            id={id}
            name={id}
            onChange={handleChange}
            row={row}
            sx={{
                columnGap: '32px'
            }}
        >
            {options.map(v =>
                <FormControlLabel
                    value={v.value}
                    key={v.value}
                    label={v.label}
                    sx={{
                        color: colors.secondaryText,
                        alignItems: 'center',
                        '& .MuiFormControlLabel-label': {
                            paddingLeft: '16px',
                            paddingTop: '3px',
                            fontSize: '16px',
                            fontWeight: 400,
                        }
                    }}
                    control={
                        <Checkbox
                            icon={<CheckboxUncheckedIcon />}
                            checkedIcon={<CheckboxCheckedIcon />}
                            checked={!!value[v.value]}
                            sx={{
                                padding: !advancedMode ? '6px 3px 6px' : '6px', //uncomment for GCP
                                // padding: '6px',
                                marginLeft: '6px',
                                stroke: colors.inputBorder,
                                '& input': {
                                    border: 'none'
                                },
                                '& .MuiSvgIcon-root': {
                                    width: '20px',
                                    height: '20px'
                                },
                                '&.Mui-checked': {
                                    fill: colors.option
                                }
                            }}
                        />
                    }
                 />
            )}
        </FormGroup>
    </FormControl>
    );
};

export default CheckboxSelector;
